export default {
  CategoryAddEdit: 'categoryAddEdit',
  CategoryDelete: 'categoryDelete',
  CategoryDeleteRefused: 'categoryDeleteRefused',
  TagAddEdit: 'TagAddEdit',
  TagDelete: 'TagDelete',
  TagDeleteRefused: 'TagDeleteRefused',
};

